import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  login (email, password) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'login',
        {
          email: email,
          password: password
        },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.loginErr)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  register (sellerName, email, sellerTel, affiliater, country, state) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'register',
        {
          email,
          affiliater,
          sellerTel,
          sellerName,
          country,
          state
        },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          resolve(response.data.header)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  active (token) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'active',
        {
          token: token
        },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success && response.data.header.resultCode !== code.urlExpired) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  acceptLicense () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'accept-license',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  resetPassword (email) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'reset-password',
        {
          email: email
        },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode === code.notRegisteredEmail) {
            reject(response.data.header.message)
          }
          if (response.data.header.resultCode === code.emailNotActivate) {
            reject(msg.emailNotActivate)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/authenticationservice.js